import { Apps } from "src/app/enums/apps.enum"
import { EnvironmentIndicator } from "src/app/enums/environment.enum"
import { IEnvironment } from "src/app/interfaces/environment.interface"

const pieAPIUrlConst = 'https://internalapi.pie.subprod.toyota.com';
const ssoAuthUrlConst = 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef';
const cdnUrlConst = 'https://da3j0du57651o.cloudfront.net';
const uri = 'https://graph.microsoft.com/v1.0/me';

const lineside = {
    local: 'http://localhost:4300/remoteEntry.js',
    dev: 'https://dev-lineside.hcm-app.toyota.com/remoteEntry.js',
    qa: 'https://qa-lineside.hcm.subprod.toyota.com/remoteEntry.js',
    prod: 'https://lineside.hotcall.toyota.com/remoteEntry.js'
}

const conveyance = {
    local: 'http://localhost:4400/remoteEntry.js',
    dev: 'https://dev-conveyance.hcm-app.toyota.com/remoteEntry.js',
    qa: 'https://qa-conveyance.hcm.subprod.toyota.com/remoteEntry.js',
    prod: 'https://conveyance.hotcall.toyota.com/remoteEntry.js'
}

const partsordering = {
    local: 'http://localhost:4500/remoteEntry.js',
    dev: 'https://dev-parts-ordering.hcm.subprod.toyota.com/remoteEntry.js',
    qa: 'https://qa-parts-ordering.hcm.subprod.toyota.com/remoteEntry.js',
    prod: 'https://parts-ordering.hotcall.toyota.com/remoteEntry.js'
}

const pieAPIUrl = {
    local: pieAPIUrlConst,
    dev: pieAPIUrlConst,
    qa: pieAPIUrlConst,
    prod: 'https://api-int.pie.toyota.com'
}

const ssoAuthUrl = {
    local: ssoAuthUrlConst,
    dev: ssoAuthUrlConst,
    qa: ssoAuthUrlConst,
    prod: 'https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb'
}

const hcmDsUrl = {
    local: 'https://api.hcm-app.toyota.com/dataservice',
    dev: 'https://api.hcm-app.toyota.com/dataservice',
    //dev:'https://dev.ds.hcm-app.toyota.com/dataservice',
    qa :'https://api.hcm.subprod.toyota.com/dataservice',
    prod: 'https://api.hotcall.toyota.com/dataservice',
}

const hcmApmUrl = {
    // local: 'https://je57sh4k37.execute-api.us-west-2.amazonaws.com/dev/graphql',
    local: 'https://awzev1yy15.execute-api.us-west-2.amazonaws.com/dev/graphql',
    dev: 'https://awzev1yy15.execute-api.us-west-2.amazonaws.com/dev/graphql',
    qa: 'https://api.hcm.subprod.toyota.com/graphql',
    prod: 'https://api.hotcall.toyota.com/graphql',
}

const pieTokenUrl = {
    local: 'https://api.hcm-app.toyota.com/common/pietoken',
    dev: 'https://api.hcm-app.toyota.com/common/pietoken',
    qa: 'https://api.hcm.subprod.toyota.com/common/pietoken',
    prod: 'https://api.hotcall.toyota.com/common/pietoken'
}
const ssoredirectUri = {
    local: 'http://localhost:4200/',
    dev: 'https://dev.hcm-app.toyota.com/',
    qa: 'https://qa.hcm.subprod.toyota.com/',
    prod: 'https://hotcall.toyota.com/'
}

const cdnUrl = {
    local: cdnUrlConst,
    dev: cdnUrlConst,
    qa: 'https://d21lb30smmlx7e.cloudfront.net',
    prod: cdnUrlConst
}

const roles = {
    lineside: ['LINESIDETL', 'ISADMIN'],
    conveyance: ['CONVEYANCEADMIN', 'CONVEYANCEVIEW', 'CONVEYANCE'],
    partsordering: ['PPC', 'PLANTADMIN', 'BUSINESSADMIN']
}

export const environments: IEnvironment = {
    local: {
        envIndicator: EnvironmentIndicator.local,
        manifest: [
            {
                name: Apps.lineside,
                url: lineside.local,
                enabled: true,
                roles: roles.lineside
            },
            {
                name: Apps.conveyance,
                url: conveyance.local,
                enabled: true,
                roles: roles.conveyance
            },
            {
                name: Apps.partsordering,
                url: partsordering.local,
                enabled: true,
                roles: roles.partsordering
            }
        ],
        auth: {
            clientId: '8f4c6f77-a378-4939-8557-c40a9ebe15ef',
            ssoAuthUrl: ssoAuthUrl.local,
            ssoredirectUri: ssoredirectUri.local,
        },
        apiConfig: {
            scopes: ['https://tmnatest.onmicrosoft.com/8f4c6f77-a378-4939-8557-c40a9ebe15ef/user_impersonation'],
            uri: uri,
            pieAPIUrl: pieAPIUrl.local,
            hcmDsUrl: hcmDsUrl.local,
            pieTokenUrl: pieTokenUrl.local,
            cdnUrl: cdnUrl.local,
            hcmApmUrl: hcmApmUrl.local
        }
    },
    dev: {
        envIndicator: EnvironmentIndicator.dev,
        manifest: [
            {
                name: Apps.lineside,
                url: lineside.dev,
                enabled: true,
                roles: roles.lineside
            },
            {
                name: Apps.conveyance,
                url: conveyance.dev,
                enabled: true,
                roles: roles.conveyance
            },
            {
                name: Apps.partsordering,
                url: partsordering.dev,
                enabled: true,
                roles: roles.partsordering
            }
        ],
        auth: {
            clientId: '8f4c6f77-a378-4939-8557-c40a9ebe15ef',
            ssoAuthUrl: ssoAuthUrl.dev,
            ssoredirectUri: ssoredirectUri.dev,
        },
        apiConfig: {
            scopes: ['https://tmnatest.onmicrosoft.com/8f4c6f77-a378-4939-8557-c40a9ebe15ef/user_impersonation'],
            uri: uri,
            pieAPIUrl: pieAPIUrl.dev,
            hcmDsUrl: hcmDsUrl.dev,
            pieTokenUrl: pieTokenUrl.dev,
            cdnUrl: cdnUrl.dev,
            hcmApmUrl: hcmApmUrl.dev
        }
    },
    qa: {
        envIndicator: EnvironmentIndicator.qa,
        manifest: [
            {
                name: Apps.lineside,
                url: lineside.qa,
                enabled: true,
                roles: roles.lineside
            },
            {
                name: Apps.conveyance,
                url: conveyance.qa,
                enabled: true,
                roles: roles.conveyance
            },
            {
                name: Apps.partsordering,
                url: partsordering.qa,
                enabled: true,
                roles: roles.partsordering
            }
        ],
        auth: {
            clientId: '551af2ec-ec59-4561-9922-2b5b283cc9ab',
            ssoAuthUrl: ssoAuthUrl.qa,
            ssoredirectUri: ssoredirectUri.qa,
        },
        apiConfig: {
            scopes: ['https://tmnatest.onmicrosoft.com/551af2ec-ec59-4561-9922-2b5b283cc9ab/user_impersonation'],
            uri: uri,
            pieAPIUrl: pieAPIUrl.qa,
            hcmDsUrl: hcmDsUrl.qa,
            pieTokenUrl: pieTokenUrl.qa,
            cdnUrl: cdnUrl.qa,
            hcmApmUrl: hcmApmUrl.qa
        }
    },
    prod: {
        envIndicator: null,
        manifest: [
            {
                name: Apps.lineside,
                url: lineside.prod,
                enabled: true,
                roles: roles.lineside
            },
            {
                name: Apps.conveyance,
                url: conveyance.prod,
                enabled: true,
                roles: roles.conveyance
            },
            {
                name: Apps.partsordering,
                url: partsordering.prod,
                enabled: true,
                roles: roles.partsordering
            }
        ],
        auth: {
            clientId: 'f666051f-92cb-4784-b483-986142af5896',
            ssoAuthUrl: ssoAuthUrl.prod,
            ssoredirectUri: ssoredirectUri.prod,
        },
        apiConfig: {
            scopes: ['https://toyota1.onmicrosoft.com/f666051f-92cb-4784-b483-986142af5896/user_impersonation'],
            uri: uri,
            pieAPIUrl: pieAPIUrl.prod,
            hcmDsUrl: hcmDsUrl.prod,
            pieTokenUrl: pieTokenUrl.prod,
            cdnUrl: cdnUrl.prod,
            hcmApmUrl: hcmApmUrl.prod
        }
    }
}